import { Mapper } from './mapper';

export const TempoResidencia = Mapper.from([
  [1, 'Prazo indeterminado'],
  [2, 'Prazo determinado'],
]);
